
    var riot = require('riot')
    
riot.tag2('pseapply', '<toaster></toaster> <div if="{!showForm &amp;&amp; allGood}" class="col-xs-12"> <h3>Thank you for your application, you will be sent an email to confirm your registration.</h3> </div> <div if="{!showForm &amp;&amp; !allGood}" class="col-xs-12"> <h3>There was an issue with your registration, please contact us so we can look into it.</h3> </div> <p>If you have a NAFEMS account, please <a href="/system/new-login/">sign-in </a>to start your application. If you do not have an account, please enter your details below to start your application</p> <form if="{showForm}" class="form-horizontal"> <div class="col-xs-12"> <h3>Personal Details</h3> <forminput label="First Name:" name="first_name" isrequired onupdate="{handleUpdate}"></forminput> <forminput label="Surname:" name="surname" isrequired onupdate="{handleUpdate}"></forminput> <forminput label="Telephone:" name="phone1" onupdate="{handleUpdate}"></forminput> <forminput label="Mobile Phone:" name="phone2" onupdate="{handleUpdate}"></forminput> <p>This email address entered here should be your personal email address. This email address will be used as a userid. Candidates are required to login to the NAFEMS website when creating/modify their PSE Certification application.</p> <forminput label="Email:" name="email" isrequired onupdate="{handleUpdate}"> </forminput> <forminput label="Password:" name="password" type="password" isrequired onupdate="{handleUpdate}"></forminput> <forminput label="Confirm Password:" name="confirm_password" type="password" isrequired onupdate="{handleUpdate}"></forminput> <p>By clicking submit and providing us with your contact details, you are giving NAFEMS your explicit consent to contact you using these details regarding your enquiry and our related products and services. You can view our privacy policy <a href="/about/legal/privacy/" target="_blank">here</a></p> </div> <div class="col-xs-12"> <div class="btn-toolbar pull-right"><a onclick="{handleRegister}" class="btn btn-success">Register</a></div> </div> </form>', 'pseapply { padding-bottom: 50px; display: block; overflow: hidden; }', '', function(opts) {
this.showForm = true;

this.data = {};

this.isValid = false;

this.allGood = true;

this.handleUpdate = (function(_this) {
  return function(val) {
    return _this.data[val.name] = val.value;
  };
})(this);

this.validate = (function(_this) {
  return function() {
    var requiredFields;
    requiredFields = ['first_name', 'surname', 'email', 'password', 'confirm_password'];
    _this.isValid = requiredFields.reduce(function(valid, field) {
      return valid && _this.validateRequired(_this.data[field]);
    }, true);
    if (!_this.isValid) {
      return requiredFields.forEach(function(field) {
        return _this.tags[field].tags['formgroup'].trigger('validate');
      });
    }
  };
})(this);

this.validateRequired = function(field) {
  var val;
  if (field == null) {
    return false;
  }
  val = field.trim();
  return (val != null ? val.length : void 0) > 0;
};

this.handleRegister = (function(_this) {
  return function() {
    _this.validate();
    if (!_this.isValid) {
      _this.tags.toaster.trigger('add', {
        title: 'Error',
        message: "There were some errors with your application",
        type: 'error'
      });
      return;
    }
    if (_this.data.password !== _this.data.confirm_password) {
      _this.tags.toaster.trigger('add', {
        title: 'Error',
        message: "Passwords don't match",
        type: 'error'
      });
      return;
    }
    delete _this.data.confirm_password;
    return fetch('/duocms/api/pse/apply', {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': window.csrf
      },
      body: JSON.stringify(_this.data)
    }).then(function(res) {
      return _this.handleErrors(res);
    }).then(function() {
      _this.showForm = false;
      _this.allGood = true;
      _this.update();
      return _this.tags.toaster.trigger('add', {
        title: 'Success',
        message: "Your application has been submitted",
        type: 'success'
      });
    })["catch"](function() {
      _this.allGood = false;
      _this.showForm = false;
      _this.update();
      return _this.tags.toaster.trigger('add', {
        title: 'Error',
        message: "Your application could not be submitted",
        type: 'error'
      });
    });
  };
})(this);

this.handleErrors = (function(_this) {
  return function(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };
})(this);
});
    
  